/** All authenticated users can use response coaching; enforcement is message-size only. */
export function canAccessCoaching(_params?: {
  isAnonymous?: boolean
  isPaid?: boolean
  isInFreeTrial?: boolean
  isAdmin?: boolean
}): boolean {
  return true
}

/** Max characters for coached draft/message text (aligned with backend). */
export const MAX_COACHING_MESSAGE_CHARS = 4_000

export function isCoachingMessageWithinLimit(text: string): boolean {
  return text.length <= MAX_COACHING_MESSAGE_CHARS
}

export function isFreeTrialActive(freeTrialEndsAt: string | null | undefined): boolean {
  if (!freeTrialEndsAt) return false
  return new Date(freeTrialEndsAt).getTime() > Date.now()
}
